'use client';

import { useAuth } from '@/context/AuthContext/AuthContext';
import { NewsFeed } from '@/components/news/NewsFeed';
import WelcomePage from './welcome/page';

export default function HomePage() {
  const { isAuthenticated, loading } = useAuth();

  // While auth state resolves, render nothing to avoid flashing the wrong view.
  if (loading) return null;

  return isAuthenticated ? <NewsFeed /> : <WelcomePage />;
}
